import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import HomeworkGroupTable from './HomeworkGroupTable';
import HomeworkGroupTiles from './HomeworkGroupTiles';
import HomeworkGroupHeaderBadge from './HomeworkGroupHeaderBadge';

const styles = theme => ({
  root: {
    marginBottom: 20,
  },
  header: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #f5f5f5',
    padding: isMobileApp
      ? '2px 10px'
      : '10px 20px',
    borderRadius: 5,
  },
  headerIconWrapper: {
    display: 'inline-block',
    marginRight: 10,
  },
  headerCountBadge: {
    display: 'inline-block',
    borderRadius: 3,
    backgroundColor: '#fff',
    color: '#616161',
    padding: '5px 10px',
    marginTop: 10,
  },
  contentNoEntries: {
    padding: 20,
  },
  contentFeedbackBadge: {
    display: 'inline-block',
    borderRadius: 15,
    backgroundColor: '#ffc107',
    color: '#212121',
    padding: '5px 15px',
  },
});

class HomeworkGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.onHeaderToogleClick = this.onHeaderToogleClick.bind(this);
  }

  onHeaderToogleClick() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    const {
      classes,
      t,
      status,
      entries,
      homeworksMeta,
      onEntryClick,
      reloadHomeworkData,
    } = this.props;
    const {
      isOpen,
    } = this.state;

    return (
      <div className={`homework-group ${classes.root}`}>
        <div className={classes.header} onClick={isMobileApp ? this.onHeaderToogleClick : null}>
          <Grid container justify="space-between">
            <Grid item>
              <div className={classes.headerIconWrapper}>
                <IconButton
                  onClick={!isMobileApp ? this.onHeaderToogleClick : null}
                  className="expand-button"
                >
                  {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              </div>
              <HomeworkGroupHeaderBadge status={status} />
            </Grid>
            <Grid item>
              <div className={classes.headerCountBadge}>
                {entries.length}
              </div>
            </Grid>
          </Grid>
        </div>
        {isOpen && (
          <div>
            {entries.length === 0 && (
              <div className={classes.contentNoEntries}>
                {t('No homework found')}
              </div>
            )}
            {entries.length > 0 && (
              <div>
                {isMobileApp && (
                  <HomeworkGroupTiles
                    entries={entries}
                    homeworksMeta={homeworksMeta}
                    onEntryClick={onEntryClick}
                    reloadHomeworkData={reloadHomeworkData}
                  />
                )}
                {!isMobileApp && (
                  <HomeworkGroupTable
                    entries={entries}
                    homeworksMeta={homeworksMeta}
                    onEntryClick={onEntryClick}
                    reloadHomeworkData={reloadHomeworkData}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(HomeworkGroup));
